document.addEventListener("click", function(e) {
  const icon = e.target.closest(".infoicon");
  const openText = document.querySelector(".infotext.show");
  const openIcon = document.querySelector(".infoicon.opened");

  // If clicking an infoicon:
  if (icon) {
    const infoText = icon.nextElementSibling;

    // If a different box is open, close it and remove icon class
    if (openText && openText !== infoText) {
      openText.classList.remove("show");
      if (openIcon) openIcon.classList.remove("opened");
    }

    // Toggle this one
    const willOpen = !infoText.classList.contains("show");
    infoText.classList.toggle("show", willOpen);
    icon.classList.toggle("opened", willOpen);
    return;
  }

  // Click outside infotext → close everything
  if (!e.target.closest(".infotext")) {
    if (openText) openText.classList.remove("show");
    if (openIcon) openIcon.classList.remove("opened");
  }
});
